<template>
  <div>
  <div data-option-section="" data-dido-tegav="this is hc-23 section"
    class="px-5 py-7 mx-auto mt-4 max-w-6xl lg:px-16 md:pt-14 md:pb-9" id="the-products">
    <div v-if="Object.keys(state.items).length > 1"
      class="flex w-full text-2xl text-white rounded bg-brownCoffee lg:text-26 xl:text-32 sm-max:flex-col">
      <div
        class="relative px-10 py-6 text-lg uppercase bg-white bg-opacity-20 lg:text-32 md-max:text-center md-max:py-3">
        Step 1
        <span class="absolute top-1/2 left-full z-10 text-4xl opacity-20 transform -translate-y-1/2" style="
            border-left: 10px solid #fff;
            border-top: 15px solid transparent;
            border-bottom: 15px solid transparent;
            content: '';
            width: 10px;
            height: 15px;
          ">
        </span>
      </div>
      <div class="px-14 py-6 text-lg lg:text-32 md-max:text-center md-max:py-3">
        Caffeinated or Decaffeinated?
      </div>
    </div>
    <!-- STEP 1 -->
    <div class="flex flex-wrap justify-center -mx-4 mt-3 text-center" v-if="Object.keys(state.items).length > 1">
      <div :class="`w-full sm-max:mb-0 px-4 my-6 md:w-1/${(
      Object.keys(state.items).length / 2
    ).toFixed(0)} lg:w-1/${Object.keys(state.items).length}`" v-for="(item, index) in state.items" :key="index">
        <label :data-event-label="item.Name" data-event-action="step_1_choice" data-event-name="experiment_event" :data-testid="'step1-choice-'+index"
          class="flex relative flex-col items-center px-4 py-10 h-full rounded-lg border-2 cursor-pointer sm-max:pb-4">
          <input type="radio" name="step1Old" class="hidden" :id="index + 'roast'" :checked="state.active.items == index"
            @click="setProduct(index)" :value="index" />
          <span class="absolute inset-0 border-2 border-[#7bbd41] rounded-lg -m-0.5 hidden show" style="
              -webkit-box-shadow: 0px 0px 0px 3px rgba(123, 189, 65, 1);
              -moz-box-shadow: 0px 0px 0px 3px rgba(123, 189, 65, 1);
              box-shadow: 0px 0px 0px 3px rgba(123, 189, 65, 1);
            "></span>
          <span class="w-7 h-7 rounded-full border-2 showbg green"></span>
          <h3 class="h-9 !pt-2 h3 text-22">{{ item.Name }}</h3>
          <p class="pb-1 mt-1 lg:text-17 text-17">Pure {{ item.Name }}</p>
          <div class="pt-5 pb-7 w-full">
            <nuxt-img class="object-contain mx-auto h-60" width="196" height="285" loading="lazy" format="webp"
              sizes="sm:218px md:218px lg:218px xl:196px" alt="" :src="item.Image.url" />
          </div>
          <p class="pb-6 text-xs">Ingredient: Organic coffee</p>
        </label>
      </div>
    </div>

    <div v-if="Object.keys(state.variants).length > 1">
      <!-- STEP 2 -->
      <div
        class="flex mt-2 w-full text-2xl text-white rounded bg-brownCoffee lg:text-26 xl:text-32 sm-max:flex-col sm-max:mt-8">
        <div
          class="relative px-10 py-6 text-lg uppercase bg-white bg-opacity-20 lg:text-32 md-max:text-center md-max:py-3">
          {{ Object.keys(state.items).length > 1 ? "Step 2" : "Step 1" }}

          <span class="absolute top-1/2 left-full z-10 opacity-20 transform -translate-y-1/2" style="
              border-left: 10px solid #fff;
              border-top: 15px solid transparent;
              border-bottom: 15px solid transparent;
              content: '';
              width: 10px;
              height: 15px;
            ">
          </span>
        </div>
        <div class="px-16 py-6 text-lg sm:px-14 lg:text-32 md-max:text-center md-max:py-3">
          Do you prefer ground or beans?
        </div>
      </div>

      <div class="flex flex-wrap justify-center -mx-4 mt-4 text-center">
        <div :class="`md:w-1/2 w-full sm-max:mb-2 px-4 my-6 lg:w-1/${Object.keys(state.variants).length
      }`" v-for="(item, index) in state.variants" :key="index">
          <label :data-event-label="item.Name" data-event-action="step_2_choice" data-event-name="experiment_event" :data-testid="'step2-choice-'+index"
            data-option="12 oz Ground" :class="(state.isSubscription && hasSellingPlans) ? '!pb-0 !px-0' : ''"
            class="flex relative flex-col items-center px-3 py-10 h-full rounded-lg border-2 cursor-pointer sm-max:py-4">
            <input type="radio" name="step2Old" class="hidden" :id="item.Name" :checked="state.active.variants == index"
              @click="setType(index)" :value="index" />
            <span class="absolute inset-0 border-2 border-[#7bbd41] rounded-lg -m-0.5 hidden show"></span>
            <span class="w-7 h-7 rounded-full border-2 showbg green"></span>
            <h3 class="pt-2 pb-1 text-lg text-xl lg:text-xl lg:text-22 md:text-28">
              {{ item.Name }}
            </h3>
            <nuxt-img :src="item.Image.url" class="block object-contain py-5 h-40 md-max:w-full"
              width="196" height="86" loading="lazy" format="webp" sizes="sm:234px md:234px lg:234px xl:234px"
              alt="product" />
            <p class="px-6 pb-6 text-base leading-5 lg:text-17 grow md-max:px-2" v-html="item.Text">
            </p>

            <p class="mt-4" v-if="state.isSubscription && hasSellingPlans">
              <span class="font-bold sm:text-xl text-lg bg-[#AC6143] block p-4 text-white">Get A Box Of Our Curated
                Seasonal Favorites For $21.08 per bag! (Normally 27.95)</span>
            </p>

          </label>
        </div>
      </div>
    </div>

    <!-- STEP 3 -->
    <div v-if="Object.keys(FilteredPacks).length > 1"
      class="flex mt-3 w-full text-2xl text-white rounded bg-brownCoffee lg:text-26 xl:text-32 sm-max:flex-col sm-max:mt-8">
      <div
        class="relative px-10 py-6 text-lg uppercase bg-white bg-opacity-20 lg:text-32 md-max:text-center md-max:py-3">
        Step 3
        <span class="absolute top-1/2 left-full z-10 opacity-20 transform -translate-y-1/2" style="
            border-left: 10px solid #fff;
            border-top: 15px solid transparent;
            border-bottom: 15px solid transparent;
            content: '';
            width: 10px;
            height: 15px;
          ">
        </span>
      </div>
      <div class="px-14 py-6 text-lg lg:text-32 md-max:text-center md-max:py-3">
        Choose How Many Bags You’d Like:
      </div>
    </div>

    <div class="flex flex-wrap justify-center mt-2 text-center" v-if="Object.keys(FilteredPacks).length > 1">
      <div :class="`w-full px-4 my-6 lg:w-1/${Object.keys(FilteredPacks).length}`"
        v-for="(item, index) in FilteredPacks" :key="index">
        <label data-index="0" :data-event-label="item.Name" data-event-action="step_3_choice" :data-testid="'step3-choice-'+index"
          data-event-name="experiment_event"
          class="flex relative flex-col items-center px-4 py-10 h-full rounded-lg border-2 cursor-pointer">
          <input type="radio" name="step3Old" class="hidden" :id="'item' + index" :checked="state.active.packs == index"
            @click="setPack(index)" :value="index" />
          <span class="absolute inset-0 border-2 border-[#7bbd41] rounded-lg -m-0.5 hidden show" style="
              -webkit-box-shadow: 0px 0px 0px 3px rgba(123, 189, 65, 1);
              -moz-box-shadow: 0px 0px 0px 3px rgba(123, 189, 65, 1);
              box-shadow: 0px 0px 0px 3px rgba(123, 189, 65, 1);
            "></span>
          <div class="h-full">
            <h3 class="pt-0 pb-1 text-lg text-[#68421e] lg:text-xl xl:text-28 font-bold md-max:pb-0">
              {{ item.Name }}
            </h3>
            <span class="text-base font-bold md-max:relative md-max:bottom-2">
              {{
      FilteredPacks.length == 3
        ? index == 1
          ? "GREAT VALUE"
          : index == 2
            ? "BEST VALUE"
            : ""
        : FilteredPacks.length == 2
          ? index == 0
            ? "GREAT VALUE"
            : index == 1
              ? "BEST VALUE"
              : ""
          : "BEST VALUE"
    }}
            </span>
            <nuxt-img :src="item.Image.url" class="block object-contain m-auto h-56" loading="lazy"
              format="webp" width="284" height="224" sizes="sm:284px md:300px lg:300px xl:284px" alt="product" />
            <p v-if="item.Text" class="mb-6 text-base">{{ item.Text }}</p>
          </div>
          <!--          <p class="text-base" style="min-height: 100px"></p>-->
          <div class="py-4 w-full">
            <div
              class="flex flex-col px-6 pt-7 pb-4 -mx-4 mt-2 space-y-0 text-white sm-max:py-2 bg-lifeboost-green-mid">
              <div v-if="!(!item.SaleRibbon || /^\s*$/.test(item.SaleRibbon))" class="special-banner">
                {{ item?.SaleRibbon }}
              </div>

              <span class="w-full leading-5 line-through md:text-xl text-15">{{
      setPrice(item)
    }}</span>
              <span class="w-full text-lg font-bold leading-5 lg:text-3xl md:text-22" v-html="item.Price"></span>
              <span class="w-full md:text-xl text-15">{{ item?.Offer }}</span>
            </div>
          </div>
          <p class="pt-1 text-sm italic">*On Continental US orders only</p>
          <span
            class="text-21 text-center uppercase w-9/12 mt-4 py-2.5 px-5 rounded border-2 border-[#7bbd41] text-[#7bbd41] block off">
            {{ item.PackSize.replace("x", "") + " Bags" }}
          </span>
          <span
            class="text-21 text-center uppercase w-9/12 mt-4 py-2.5 px-5 rounded border-2 border-[#7bbd41] bg-[#7bbd41] text-white hidden show">
            {{ item.PackSize.replace("x", "") + " Bags" }}
          </span>
        </label>
      </div>
    </div>
    <div v-if="state.isSubscription && hasSellingPlans">
      <div class="text-lg text-red-400 border-red-400">
        <p class="m-auto mt-4 mb-4 text-lg font-medium leading-tight text-gray-900 sm-max:text-xl">
          {{ state.items[state.active.items].Name }} by Lifeboost is an ongoing subscription service that
          is automatically charged each season <span class="font-bold">({{
      state.items[state.active.items].Variants[state.active.variants].Pack[state.active.packs].Price }}
            USD)</span> to the payment method
          provided until you cancel. Taxes, & shipping fees. You may cancel your subscription online at any time before
          your next bill date, or by contacting Lifeboost Coffee Support at 1-800-479-1596, or by contacting us
          <a class="underline text-link" target="_blank" href="https://lifeboostcoffee.com/pages/contact-us">here.</a>️
        </p>
      </div>
      <div class="flex flex-row justify-center my-10 space-x-6">
        <div class="flex items-start">
          <div class="flex items-center h-6">
            <input id="remember" aria-describedby="remember" type="checkbox"
              :class="['relative w-6 h-6 border drop-shadow-lg rounded cursor-pointer !p-3 !mt-4 bottom-1 bg-gray-50 focus:ring-3 focus:ring-primary-300', { 'highlight-checkbox': highlightCheckbox }]"
              v-model="checkboxChecked" @change="highlightCheckbox = false" required>
          </div>
        </div>
        <div class="max-w-md text-left text-sm !ml-4">


          <label for="remember" class="text-lg font-bold text-gray-700 cursor-pointer text-body font-gotham">

            By clicking "Join our club now", you are agreeing to our Terms of Use and Sale and
            <a class="text-link" href="https://lifeboostcoffee.com/pages/terms" target="_blank">
              Lifeboost Coffee Terms
            </a>

            and Conditions


          </label>
        </div>
      </div>
    </div> 
    <button type="button" data-event-name="experiment_event" data-event-action="CTA Click | Add To Cart" data-event-label="cta_add_to_cart" data-testid="cta-button"
      data-cart-add=""
      class="p-3 py-1 mt-2 mb-0 w-full font-bold text-center text-white uppercase rounded shadow-md transition-all bg-orangebtn font-ww-medium sm-max:text-32 text-51 hover:opacity-75"
      @click="handleButtonClick($event)" :disabled="!stockCheck()"
      :class="(!stockCheck() && 'grayscale-1') || (highlightCheckbox && 'highlight-checkbox') || (devMode && 'split-test-outline')"
      style="box-shadow: 0 -4px 0 #c7642d inset">
      {{ !stockCheck() ? "OUT OF STOCK" : state.isSubscription ? "JOIN OUR CLUB NOW" : "ADD TO CART" }}
    </button>
  </div>


  <div class="relative flex items-center justify-center customPopup2 fixed w-full h-full z-[21474830004] left-0 top-0"
    v-show="state.upgrade.show" :class="state.upgrade.show ? 'active' : ''" id="tail">
    <div id="modal_1"
      class="flex overflow-auto fixed top-0 z-50 items-start w-full h-screen bg-gray-800 bg-opacity-50">
      <div class="flex justify-center items-center mx-auto w-full max-w-6xl md:py-20 md:px-20 xs-max:relative">
        <div
          class="flex relative flex-col justify-center items-center px-4 py-2 pt-5 pb-8 w-full max-w-screen-lg bg-white border-t-8 border-yellow-600 shadow-lg md:w-auto md:py-14 lg:px-12 xl:px-16">
          <div class="w-full modal-header">
            <div class="flex justify-between mb-2 space-x-3 w-full text-sm font-semibold">
              <div class="item">Add to Cart</div>
              <div class="text-center item sm:text-left">Upgrade Options</div>
              <div class="text-right item">Secure Checkout</div>
            </div>
            <div class="mb-3 w-full progress progress-striped active">
              <div class="progress-bar progress-bar-success" :class="modal.crosssell.show ? 'w-3/4' : 'w-1/2'">
                <span>&nbsp;</span>
              </div>
            </div>
          </div>
          <!-- modal body 1 start -->
          <div class="w-full modal-body" v-show="modal.upsell.show">
            <div class="py-2 w-full text-center bg-gray-100 border border-gray-300" role="banner">
              <p class="m-0 text-lg lg:text-lg xl:text-xl" v-text="state.upgrade.UpSell.PreHeader"></p>
              <p class="px-2 m-0 mx-auto w-full text-lg font-bold text-center uppercase opacity-75 md:w-4/5 sm:text-2xl md:text-3xl lg:text-4xl font-ww-medium"
                v-text="state.upgrade.UpSell.Header"></p>
            </div>
            <div class="flex items-center px-0 mt-4 space-x-4 md:space-x-8">
              <div class="h-auto item">
                <h3 role="main"
                  class="text-2xl font-semibold leading-7 text-left text-gray-800 lg:text-3xl lg:leading-9">
                  Lucky You!
                </h3>
                <div data-body-copy class="grid overflow-hidden grid-cols-3 gap-2 sm:grid-cols-8">
                  <!-- You’ve found our
                  <span class="italic">New Customer Special</span> - our
                  biggest savings anywhere in our store. -->
                  <p class="col-span-2 col-start-1 row-start-1 mt-2 text-base font-normal text-justify sm:col-span-6 sm:text-xl" v-text="state.upgrade.UpSell.SubHeader">
                  </p>
                  <div class="flex col-span-2 row-start-1 items-center sm:col-start-7 sm:col-span-2 sm:row-span-2 item">
                    <img class="mx-auto sm:w-40" loading="lazy" :src="state.upgrade.UpSell.Image" />
                  </div>
                </div>
              </div>
            </div>
            <div class="space-y-3 w-full text-center sm:px-5 md:space-y-4">
              <a @click="setChoice(true)" class="btn--special">Yes!
                Upgrade My Savings
                <svg class="absolute inset-y-0 right-4 my-auto w-auto h-2.5 md:right-6 lg:h-4 xl:h-auto"
                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 29"
                  width="16px" height="29px">
                  <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
                    d="M15.704,15.145 L2.146,28.703 C1.789,29.060 1.211,29.060 0.854,28.703 C0.498,28.347 0.498,27.769 0.854,27.412 L13.767,14.499 L0.854,1.587 C0.498,1.231 0.498,0.652 0.854,0.296 C1.211,-0.061 1.789,-0.061 2.146,0.296 L15.704,13.854 C16.060,14.211 16.060,14.788 15.704,15.145 Z">
                  </path>
                </svg>
              </a>
            </div>
            <a @click="setChoice(false)" href="javascript:void(0)"
              class="block text-base leading-none text-center text-gray-800 underline border-b border-transparent focus:outline-none">No
              thanks, I’ll pass on this one-time offer</a>
            <button @click="setChoice(false)"
              class="absolute top-4 right-4 text-gray-800 cursor-pointer lg:top-6 lg:right-6 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
              aria-label="close">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                ...
              </svg>
            </button>
          </div>
          <!-- modal body 1 end -->
          <!-- modal body 2 start -->
          <div class="w-full modal-body" v-show="modal.crosssell.show">
            <div class="py-2 w-full text-center bg-gray-100 border border-gray-300" role="banner">
              <h3 class="px-2 m-0 mx-auto text-lg font-bold text-center uppercase opacity-75 sm:text-2xl md:text-3xl lg:text-3xl font-ww-medium"
                v-text="state.upgrade.CrossSell.Header"></h3>
            </div>
            <div data-body-copy class="grid overflow-hidden grid-cols-3 gap-2 sm:grid-cols-8">
                  <p class="col-span-2 col-start-1 row-start-1 mt-2 text-base font-normal text-justify sm:col-span-6 sm:text-xl" v-text="state.upgrade.CrossSell.Body">
                  </p>
                  <p class="col-span-3 row-start-2 mt-2 text-base font-normal text-justify sm:col-start-1 sm:row-start-2 sm:col-span-6 sm:text-xl" v-html="state.upgrade.CrossSell.PricenSave">
                  </p>
                  <div class="flex col-span-2 row-start-1 items-center sm:col-start-7 sm:col-span-2 sm:row-span-2 item">
                    <img class="mx-auto sm:w-40" loading="lazy" :src="state.upgrade.CrossSell.Image" />
                  </div>
                </div>
            <div class="px-5 space-y-3 w-full text-center md:space-y-4">
              <a @click="setChoice(true)" data-add-upgrade-bundle class="btn--special">Yes!
                Upgrade My Order
                <svg class="absolute inset-y-0 right-4 my-auto w-auto h-2.5 md:right-6 lg:h-4 xl:h-auto"
                  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 29"
                  width="16px" height="29px">
                  <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
                    d="M15.704,15.145 L2.146,28.703 C1.789,29.060 1.211,29.060 0.854,28.703 C0.498,28.347 0.498,27.769 0.854,27.412 L13.767,14.499 L0.854,1.587 C0.498,1.231 0.498,0.652 0.854,0.296 C1.211,-0.061 1.789,-0.061 2.146,0.296 L15.704,13.854 C16.060,14.211 16.060,14.788 15.704,15.145 Z">
                  </path>
                </svg>
              </a>
            </div>
            <a @click="setChoice(false)" data-add-default-final href="javascript:void(0)"
              class="block text-sm leading-none text-center text-gray-800 underline border-b border-transparent focus:outline-none">
              No thanks, I’ll pass on this opportunity to try these three roasts
              at a big discount…
            </a>
            <button @click="setChoice(false)"
              class="absolute top-6 right-6 text-gray-800 cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800"
              aria-label="close">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                ...
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script setup>
import Engine from "~/composables/Engine.js";
const runEngine = new Engine();
const route = useRoute();
const page = ref({ Products: { data: {} }, AOVBooster: [], PreselPack: null });
page.value = await runEngine.queryPage(
  route.path.split("/").at(-1).split("?")[0]
);
const products = computed(() => {
  return Object.keys(page.value.Products).reduce(
    (r, v) => ({ ...r, [v]: page.value.Products[v] }),
    {}
  );
});

const upgrades = computed(() =>
  page.value.AOVBooster.length ? page.value.AOVBooster[0] : []
);
const Preselected = computed(() =>
  page.value.PreselPack !== null ? page.value.PreselPack - 1 : 0
);

const highlightCheckbox = ref(false);
const checkboxChecked = ref(false);

const state = reactive({
  layout: ref(""),
  layoutPopup: ref(""),
  subscriptionPage: ref(false),
  pageSteps: ref({}),
  items: products,
  upgrades: upgrades,
  variants: products.value[0].Variants,
  packs: products.value[0].Variants[0].Pack.filter((obj) => obj.Active),
  images: products.value[0].Variants[0].variant.Gallery[0],
  unit: ref({
    beans: ["bag", "bags"],
    pods: ["box", "boxes"],
    ground: ["bag", "bags"],
    wholebeans: ["bag", "bags"],
    coffeeground: ["bag", "bags"],
    coffeebeans: ["bag", "bags"],
    coffeepods: ["box", "boxes"],
  }),
  currentUnit: ref(["bag", "bags"]),
  active: {
    items: 0,
    variants: 0,
    packs: Preselected.value,
    sellingPlan: 0,
  },
  upgrade: ref({
    UpSell: {},
    CrossSell: {},
    show: false,
  }),
  isSubscription: page.value.Subscription ?? false,
  regular: ref({}),
  trackingStack: ref({}),
});

const FilteredPacks = computed(() => {
  return state.items[state.active.items].Variants[
    state.active.variants
  ].Pack.filter((obj) => obj.Active);
});

// Modal object
const modal = reactive({
  show: true,
  page: true,
  product: {
    qty: 0,
    packName: "",
    Coupon: [],
    variantID: 40029155524668,
  },
  upsell: {
    show: true,
    activate: false,
  },
  crosssell: {
    show: false,
    variantId: 32453656150076,
    activate: false,
  },
});

// const setProduct = (index) => {
//   const newPacks = products.value[index].Variants[0].Pack.filter((obj) => obj.Active);
// state.packs.splice(0, state.packs.length, ...newPacks);
//     }
// console.log(modal.upsell.show);
// Methods
const setProductModal = (input) => {
  modal.product = {
    qty: input.qty,
    packName: input.packName,
    Coupon: input.Coupon,
    variantID: input.variantID,
  };
  modal.crosssell.variantId = input.crossSellID;
};

const trackEvent = inject("trackEvent");

const setProduct = (index) => {
  index = parseInt(index);
  state.variants = products.value[index].Variants;
  state.active.items = parseInt(index);
  state.packs = products.value[index].Variants[0].Pack.filter(
    (obj) => obj.Active
  );
  state.images =
    products.value[index].Variants[0].variant.Gallery[0];
  state.active.variants = 0;
  state.active.packs = parseInt(Preselected.value);

};
const setType = (index) => {
  state.active.variants = parseInt(index);

  state.images =
    state.items[state.active.items].Variants[
      state.active.variants
    ].variant.Gallery[0];
  state.active.packs = parseInt(Preselected.value);
  state.packs = state.items[state.active.items].Variants[
    state.active.variants
  ].Pack.filter((obj) => obj.Active);
};

const setPack = (index) => {
  state.active.packs = parseInt(index);
};

const setChoice = (choice) => {
  if (modal.upsell.show === true) {
    modal.upsell.activate = choice;

    // track upsell offer decision
    if (choice) {
      trackOffer.accept({
        id: 1,
        name: 'Double Order Upsell'
      });
    } else {
      trackOffer.decline({
        id: 1,
        name: 'Double Order Upsell'
      });
    }

    modal.upsell.show = false;
    modal.crosssell.show = true;

    // track cross-sell view
    trackOffer.view({
      id: 2,
      name: 'Signature Bundle Cross-sell' // Double Order or Signature Bundle
    });
  } else if (modal.crosssell.show === true) {

    modal.crosssell.activate = choice;

    // track cross-sell offer decision
    if (choice) {
      trackOffer.accept({
        id: 2,
        name: 'Signature Bundle Cross-sell'
      });
    } else {
      trackOffer.decline({
        id: 2,
        name: 'Signature Bundle Cross-sell'
      });
    }
    checkOut();
  }
};


const checkOut = () => {
  const crossSellId = modal.crosssell.activate && modal.crosssell.variantId;
  runEngine.checkout(
    modal.product.variantID,
    modal.upsell.activate ? modal.product.qty * 2 : modal.product.qty,
    modal.upsell.activate ? modal.product.Coupon[0] : modal.product.Coupon[1],
    modal.product.packName,
    null,
    crossSellId,
    trackEvent
  );

};



const setProductDetails = (index) => {
  index = parseInt(index);
  state.variants = products.value[index].Variants;
  state.active.items = index;
  state.packs = products.value[index].Variants[0].Pack.filter(
    (obj) => obj.Active
  );
  state.images =
    products.value[index].Variants[0].variant.Gallery[0];
  state.active.variants = 0;
  state.active.packs = Preselected.value;
};

const setPrice = (item) => {
  const amount = item.PackSize.replace("x", "");
  const sale =
    state.variants[state.active.variants].variant.VariantPrice;
  return "$" + (amount * sale).toFixed(2);
};

const addUpgradeToCart = (accepted) => {
  accepted ? onCheckout(state.upgrade) : onCheckout(state.regular);
};

const onCheckout = (Item) => {
  runEngine.checkout(
    Item.varID,
    Item.quantity,
    Item.Coupon,
    Item.pack,
    null,
    null,
    trackEvent
  );
};

const stockCheck = () => {
  return state.items[state.active.items].Variants[state.active.variants].variant
    .inStock;
};

const hasSellingPlans = () => {

  return state.items[state.active.items].Variants[state.active.variants].variant.SellingPlans.length > 0;
}
// gid://shopify/SellingPlan/970981436
const getSellingPlan = () => {
  // return the last selling plan id example from gid://shopify/SellingPlan/970981436 return only 970981436
  return state.items[state.active.items].Variants[state.active.variants].variant.SellingPlans[state.active.sellingPlan].sellingPlan.id.split("/").at(-1);
}

const getStep = (step) => {
  switch (step) {
    case 1:
      return "Step 1";
    case 2:
      return Object.keys(state.items).length > 1 ? "Step 2" : "Step 1";
    case 3:
      return Object.keys(state.items).length > 1 && state.variants.length > 1
        ? "Step 3"
        : Object.keys(state.items).length > 1 || state.variants.length > 1
          ? "Step 2"
          : "Step 1";
    default:
      return "";
  }
};

const devMode = useCookie('devMode')

// Lifecycle hook onMounted (equivalent to init in Alpine.js)
onMounted(() => {
  runEngine.fetchProduct(["6938980876348", "6980372004924", "7148455624764", "8023271014460"]).then(() => {
    Object.keys(state.items).map((key) => {
      return state.items[key].Variants.map((variant, index) => {
        state.items[key].Variants[index].variant.inStock =
          runEngine.getInStock(variant.variant.VariantID);
        state.items[key].Variants[index].variant.SellingPlans =
          runEngine.getVariant(variant.variant.VariantID).sellingPlanAllocations.nodes;
      });
    });
  });
});

const addToCart = () => {
  const item = state.items[state.active.items];
  const variant = item.Variants[state.active.variants];
  const pack = variant.Pack[state.active.packs];
  const variantID = variant.variant.VariantID;

  if (typeof state.upgrades.CrossSellOffer !== "undefined") {
    document.body.style.overflow = "hidden";
    const upgradeOffer = products.value[state.active.items].Variants[
      state.active.variants
    ].Pack.filter(
      (obj) => obj.PackSize === "x" + pack.PackSize.replace("x", "") * 2
    );
    const oferTa = upgradeOffer[0];
    const CrossSellVariant = JSON.parse(
      state.upgrades.CrossSellOffer.VariantId.VariantSKU
    )[variant.Name.toLowerCase().includes("bean") ? "beans" : "ground"];
    setProductModal({
      qty: pack.PackSize.replace("x", ""),
      packName: pack.Name,
      Coupon: [oferTa.Coupon, pack.Coupon],
      variantID: variantID,
      crossSellID: CrossSellVariant,
    });
    state.upgrade = {
      product: item.Name,
      pack: pack.Name,
      variant: variant.Name,
      varID: variantID,
      quantity: pack.PackSize.replace("x", "") * 2,
      PackDiff: pack.PackSize.replace("x", "") / 2,
      UpSell: {
        PreHeader: state.upgrades.UpsellOffer.PreHeader,
        Header: state.upgrades.UpsellOffer.Header,
        SubHeader: state.upgrades.UpsellOffer.SubHeader,
        Image: state.upgrades.UpsellOffer.Image.url,
        ButtonText: "Yes! Upgrade My Order",
      },
      CrossSell: {
        Body: state.upgrades.CrossSellOffer.Body,
        Header: state.upgrades.CrossSellOffer.Header,
        Image: state.upgrades.CrossSellOffer.Image.url,
        PricenSave: state.upgrades.CrossSellOffer.PricenSave,
        ButtonText: "Yes! Upgrade My Order",
      },
      // Image: pack.Image.url,
      OfferType: oferTa.OfferType,
      Discount: oferTa.Discount,
      Coupon: oferTa.Coupon,
      Price: oferTa.Price,
      show: true,
    };
  } else if (typeof state.upgrades.UpsellPackOffer !== "undefined") {
    document.body.style.overflow = "hidden";
    const xUpgradeQty = state.upgrades.UpsellPackOffer.filter(
      (obj) => obj.PackSizeRun === pack.PackSize
    );
    const oferTi = xUpgradeQty[0];
    const upgradeOffer = products.value[state.active.items].Variants[
      state.active.variants
    ].Pack.filter((obj) => obj.PackSize === oferTi.PackUpgrade);
    const oferTa = upgradeOffer[0];
    if (state.layoutPopup == "L02") {
      setProductModal({
        qty: pack.PackSize.replace("x", ""),
        packName: pack.Name,
        Coupon: [oferTa.Coupon, pack.Coupon],
        variantID: variantID,
      });
    }
    state.upgrade = {
      product: item.Name,
      pack: pack.Name,
      variant: variant.Name,
      varID: variantID,
      quantity: oferTi.PackUpgrade.replace("x", ""),
      PackDiff:
        oferTi.PackUpgrade.replace("x", "") -
        oferTi.PackSizeRun.replace("x", ""),
      PreHeader: oferTi.PreHeader,
      Header: oferTi.Header,
      SubHeader: oferTi.SubHeader,
      Image: oferTi.Image.url,
      // Image: pack.Image.url,
      OfferType: oferTa.OfferType,
      Discount: oferTa.Discount,
      Coupon: oferTa.Coupon,
      Price: oferTa.Price,
      ButtonText: oferTi.ButtonText,
      show: true,
    };
    state.regular = {
      product: item.Name,
      variant: variant.Name,
      pack: pack.Name,
      quantity: pack.PackSize.replace("x", ""),
      Coupon: pack.Coupon,
      varID: variantID,
    };
  } else if (state.isSubscription && hasSellingPlans()) {
    runEngine.checkout(
      variantID,
      pack.PackSize.replace("x", ""),
      pack.Coupon,
      pack.Name,
      getSellingPlan(),
      null,
      trackEvent
    );
  } else {
    runEngine.checkout(
      variantID,
      pack.PackSize.replace("x", ""),
      pack.Coupon,
      pack.Name,
      null,
      null,
      trackEvent
    );
  }
};

const handleButtonClick = (event) => {
  const noFixed = forceNoFixed()
  noFixed.value = true;

  if (!checkboxChecked.value && state.isSubscription) {
    highlightCheckbox.value = true;
  } else {
    addToCart();

    // track upsell offer view
    trackOffer.view({
      id: 1,
      name: 'Double Order Upsell' // Double Order or Signature Bundle
    });
    builderTrackEvent("add_to_cart_button_click");
    // eventTracker(event);
  }
};



defineBuilderComponent({
    friendlyName: "Swatches",
    canHaveChildren: true
});
</script>

<style scoped>
.highlight-checkbox {
  box-shadow: 0 0 5px red;
}

label * {
  cursor: pointer;
  pointer-events: none;
}

label input:checked~.show {
  display: block;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

label input:checked~.showbg {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

label input:checked~.showbg.gray {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

label input:checked~.showbg.green {
  --tw-border-opacity: 1;
  border-color: rgba(156, 163, 175, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(123, 189, 65, var(--tw-bg-opacity));
}

label input:checked~.showbg.yellow {
  --tw-bg-opacity: 1;
  background-color: rgba(250, 204, 21, var(--tw-bg-opacity));
}

label input:checked~.showbg.cath {
  --tw-bg-opacity: 1;
  background-color: rgba(113, 63, 18, var(--tw-bg-opacity));
}

label input:checked~.showcolor-white {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

label input:checked~.text-o {
  --tw-text-opacity: 1;
  color: rgba(202, 138, 4, var(--tw-text-opacity));
}

label input:checked~.off {
  display: none;
}

.swatch {
  position: relative;
  cursor: pointer;
  border-radius: 0.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(156, 163, 175, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  padding-left: 0.875rem;
  padding-right: 0.875rem;
  font-weight: 500;
}

@media (min-width: 1024px) {
  .swatch {
    padding: 0.875rem;
  }
}

.swatch--tshirt {
  width: auto;
  width: initial;
  margin-bottom: 10px;
}

.swatch--active {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

.swatch--active svg {
  display: block !important;
}

.swatch--disabled {
  opacity: 0.15;
  text-decoration: line-through;
}

label input:checked~.swatch--packs {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

label input:checked~.swatch--packs.gray {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

label input:checked~.showbg.swatch--packs {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

label input:checked~.swatch--packs.green {
  --tw-border-opacity: 1;
  border-color: rgba(156, 163, 175, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(123, 189, 65, var(--tw-bg-opacity));
}

label input:checked~.swatch--packs.yellow {
  --tw-bg-opacity: 1;
  background-color: rgba(250, 204, 21, var(--tw-bg-opacity));
}

label input:checked~.swatch--packs.cath {
  --tw-bg-opacity: 1;
  background-color: rgba(113, 63, 18, var(--tw-bg-opacity));
}

.swatch--packs {
  position: absolute;
  position: relative;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: 0;
  min-width: -moz-min-content;
  min-width: min-content;
  cursor: pointer;
  border-radius: 0.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(156, 163, 175, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  font-weight: 500;
}

.swatch--packs.swatch--active {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

.swatch--packs {
  padding: 15px 0 0 0;
  width: inherit;
}

.swatch {
  width: inherit;
}

.swatch--packs:nth-child(1) {
  padding: 15px 0 !important;
}

label input:checked~.off {
  display: none;
}

imglabel input:checked~.off[data-sizes="auto"] {
  display: none;
}

label.lazy__container input:checked~.off {
  display: none;
}

label input:checked~.text-o {
  --tw-text-opacity: 1;
  color: rgba(202, 138, 4, var(--tw-text-opacity));
}

.progress {
  background-color: #f5f5f5;
  border-radius: 3px;
  box-shadow: none;
}

.progress-bar {
  background-color: #2196f3;
  box-shadow: none;
}

@-webkit-keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }

  to {
    background-position: 0 0;
  }
}

@keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }

  to {
    background-position: 0 0;
  }
}

.progress-bar.active,
.progress.active .progress-bar {
  -webkit-animation: progress-bar-stripes 2s linear infinite;
  -o-animation: progress-bar-stripes 2s linear infinite;
  animation: progress-bar-stripes 2s linear infinite;
}

.progress-bar-striped,
.progress-striped .progress-bar {
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.15) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.15) 50%,
      rgba(255, 255, 255, 0.15) 75%,
      transparent 75%,
      transparent);
  background-image: -o-linear-gradient(45deg,
      rgba(255, 255, 255, 0.15) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.15) 50%,
      rgba(255, 255, 255, 0.15) 75%,
      transparent 75%,
      transparent);
  background-image: linear-gradient(45deg,
      rgba(255, 255, 255, 0.15) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.15) 50%,
      rgba(255, 255, 255, 0.15) 75%,
      transparent 75%,
      transparent);
  background-size: 40px 40px;
}

.progress-bar-success {
  background-color: #00a968;
}

button.cart-popup-close:after {
  display: inline-block;
  content: "\00d7";
}

button.cart-popup-close {
  background: none;
  color: inherit;
  border: none;
  font-family: "Gruppo";
  color: #4e4e4e;
  font-size: 30px;
  position: absolute;
  right: 15px;
  top: 10px;
}

.upgrade-save-btn {
  cursor: pointer;
}

.product-image img,
.temp-fix {
  height: 200px;
  object-fit: contain;
}

.fix-height {
  height: 125px;
  object-fit: contain;
}

.fix-one-height {
  height: 240px;
  object-fit: contain;
}

[x-cloak] {
  display: none !important;
}

.grayscale-1 {
  filter: grayscale(1);
  pointer-events: none;
}

.flex-viewport {
  min-height: 550px;
}

@media only screen and (min-width: 500px) {
  .flex-viewport {
    min-height: 650px;
  }
}
</style>
